/* eslint-disable react/no-did-update-set-state */
import cx from "classnames";
import { MDBAnimation } from "mdbreact";
import React, { Component } from "react";
import { connect } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ListServiceNew from "~/components/desktop/molecules/ListServiceNew";
import { urlBannerHomeDesktop } from "~/utils/manageResource";
import styles from "./style.module.scss";

import partnerId from "~/utils/partner";
class BannerHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundImage: "",
      bgByPartnerId: ""
    };
  }

  async componentDidMount() {
    try {
      const url = "https://cms.medpro.com.vn/banners?partnerId=" + partnerId;

      const res = await fetch(url);
      const dta = await res.json();

      this.setState({
        bgByPartnerId: dta[0]
      });
    } catch (error) {
      this.setState({
        bgByPartnerId: ""
      });
    }
  }

  render() {
    const { isMobile } = this.props;
    return (
      <MDBAnimation className={styles.container}>
        <div className={styles.slideBanerHome}>
          <img
            className={cx(styles.imgLeft)}
            src={urlBannerHomeDesktop}
            alt="banner"
          />
          <div className={cx(styles.rightItem)}>
            <div>
              <img
                className={cx(styles.imgRight)}
                src={
                  isMobile
                    ? "https://cdn-pkh.longvan.net/testing-partner/526fbc52-fe63-4405-ac32-0c985cb92020-medpro_x_fundiin_baao_mobile_188x110_copy_2.png"
                    : "https://cdn-pkh.longvan.net/testing-partner/b769427f-b128-4da5-b7d9-17fc6cd9cc76-medpro_x_fundiin_baao_ws_400x192_copy.png"
                }
                alt="banner"
              />
            </div>
            <div>
              <img
                className={cx(styles.imgRight)}
                src={
                  isMobile
                    ? "https://cdn-pkh.longvan.net/testing-partner/261a2dc7-9e28-4bcd-8823-a091b0868253-medpro_x_umc2_baao_mobile_188x110_copy_3.png"
                    : "https://cdn-pkh.longvan.net/testing-partner/c7ff7d35-b219-47eb-a138-2d3aa4582591-medpro_x_umc2_baao_ws_400x192_copy_2.png"
                }
                alt="banner"
              />
            </div>
          </div>
        </div>
        <ListServiceNew />
      </MDBAnimation>
    );
  }
}

const mapStateToProps = state => {
  const checkIfMobile = () => {
    return (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      ) || window.innerWidth <= 768
    );
  };

  return {
    isMobile: checkIfMobile()
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BannerHome);

const settings = {
  arrows: true,
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  fade: true,
  speed: 900,
  cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
  touchThreshold: 100,
  lazyLoad: true,
  dots: true
};
